import React, { createContext, useState } from "react";

const InputProvider = (props) => {
    const [authInformation, setAuthInformation] = useState({});

    return (
        <InputContext.Provider
            value={[authInformation, setAuthInformation]}
        >
            {props.children}
        </InputContext.Provider>
    )
}
export default InputProvider;
export const InputContext = createContext({});
